import { z } from "zod";
import { matchLocaleSchema } from "./venue.js";

export const fictionalCocktailRequestSchema = z.object({
  mood: z.string().trim().min(3).max(240),
  locale: matchLocaleSchema.default("zh"),
});
export type FictionalCocktailRequest = z.infer<typeof fictionalCocktailRequestSchema>;

export const fictionalCocktailSchema = z.object({
  name: z.string().trim().min(1).max(80),
  tastesLike: z.string().trim().min(1).max(180),
  flavorProfile: z.string().trim().min(1).max(120),
  baseSpirit: z.string().trim().min(1).max(40).nullable(),
  ingredients: z.array(z.string().trim().min(1).max(60)).min(3).max(6),
  whyThisMatch: z.string().trim().min(1).max(180),
  roast: z.string().trim().min(1).max(120),
}).strict();
export type FictionalCocktail = z.infer<typeof fictionalCocktailSchema>;

export const genericCocktailMatchSchema = z.object({
  kind: z.literal("generic_cocktail"),
  cocktail: fictionalCocktailSchema,
  traceId: z.string().min(1).max(200),
  locale: matchLocaleSchema,
  illustrationUrl: z.string().regex(/^\/fictional-cocktails\/illustrations\/cocktail-(?:0[1-9]|1[0-2])\.png$/),
}).strict();
export type GenericCocktailMatch = z.infer<typeof genericCocktailMatchSchema>;
